import React from 'react';
import { Trans } from '@lingui/react';

import { Notification } from '@rover/icons';
import { Flex, Text } from '@rover/kibble/core';
import { useTheme } from '@rover/kibble/themes';

const ICON_BOX_SIZE = 56;
const ICON_SIZE = 19;

const NoNotifications = (): JSX.Element => {
  const theme = useTheme();

  return (
    <Flex
      data-testid="no-notifications"
      flex="1"
      flexDirection="column"
      alignItems="center"
      justifyContent="center"
    >
      <Flex
        flex={`0 0 ${ICON_BOX_SIZE}px`}
        border="1px dashed"
        borderColor={theme.colors.border.primary.toString()}
        height={`${ICON_BOX_SIZE}px`}
        width={`${ICON_BOX_SIZE}px`}
        marginBottom="3x"
        alignItems="center"
        justifyContent="center"
        borderRadius="4px"
      >
        <Notification
          fill={theme.colors.border.primary.toString()}
          height={ICON_SIZE}
          width={ICON_SIZE}
        />
      </Flex>
      <Text
        size="100"
        fontWeight="semibold"
        marginBottom="2x"
        sx={{ color: theme.colors.text.secondary.toString(), height: '20px' }}
      >
        <Trans id="No Notifications" />
      </Text>
      <Text size="100" sx={{ color: theme.colors.text.tertiary.toString() }}>
        <Trans id="You’re all caught up!" />
      </Text>
    </Flex>
  );
};

export default NoNotifications;
